import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getScripts } from 'redux/reducers/errorCorrections/selectors';
import { startScriptRequest } from 'redux/reducers/errorCorrections/reducer';
import { IErrorCorrectionsScriptParameterValue, TLaunchCorrectionScriptProps } from './types';
import { LaunchCorrectionScriptDialog } from './LaunchCorrectionScriptDialog';

export const LaunchCorrectionScript: FC<TLaunchCorrectionScriptProps> = ({ open, setClose }) => {
	const params = useParams<{ errorId?: string }>();
	const { errorId } = params;
	const dispatch = useDispatch();
	const scripts = useSelector(getScripts);

	const [activeStep, setActiveStep] = useState(0);
	const [submitted, setSubmitted] = useState(false);
	const [selectedScript, setSelectedScript] = useState<number | null>(null);
	const [errorParams, setErrorParams] = useState<IErrorCorrectionsScriptParameterValue[]>(
		scripts?.[selectedScript ?? 0]?.parameters.map((param) => {
			return {
				fieldName: param.fieldName,
				name: param.name,
				value: '',
				type: param.type,
			};
		}) ?? [],
	);

	const handleEraseForm = () => {
		setSelectedScript(null);
		setErrorParams([]);
		setActiveStep(0);
	};

	const handleSubmit = () => {
		if (selectedScript === null || scripts === null) return;
		dispatch(
			startScriptRequest({
				errorId: +errorId!,
				scriptId: scripts[selectedScript].id,
				parameters:
					// {},
					errorParams.reduce<{ [key: string]: any }>((acc, item) => {
						acc[item.fieldName] = String(item.value);
						return acc;
					}, {}),
			}),
		);
		setSubmitted(true);
		handleEraseForm();
		setClose();
	};

	return (
		<LaunchCorrectionScriptDialog
			open={open}
			setClose={setClose}
			handleSubmit={handleSubmit}
			setErrorParams={setErrorParams}
			setSelectedScript={setSelectedScript}
			setActiveStep={setActiveStep}
			activeStep={activeStep}
			errorParams={errorParams}
			selectedScript={selectedScript}
			setSubmitted={setSubmitted}
			submitted={submitted}
		/>
	);
};
